import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/BalanceSheet/AccountingReportBalanceSheetAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportBalanceSheetActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/BalanceSheet/AccountingReportBalanceSheet")
	}

	render() {
		return (
			<Activity 
				name="AccountingReportBalanceSheet"
				RenderedComponent={this.RenderedComponent}
				context="AccountingReportBalanceSheet"
				action="AccountingReportBalanceSheet"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportBalanceSheetActivity)
